/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

/*
 * L'inventario del cliente azienda. Sono le stesse rotte che usa l'area cliente:
 * quello che cambia e' solo chi ha il permesso di indicare un clienteId diverso
 * dal proprio, e quello lo decide il backend.
 */
export const inventarioAPI = {
  list: async (clienteId, params = {}) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}`, { params });
    return data;
  },

  riepilogo: async (clienteId) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}/riepilogo`);
    return data;
  },

  categorie: async (clienteId) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}/categorie`);
    return data;
  },

  crea: async (clienteId, payload) => {
    const { data } = await apiClient.post(`/inventario/${clienteId}`, payload);
    return data;
  },

  modifica: async (articoloId, payload) => {
    const { data } = await apiClient.put(`/inventario/articolo/${articoloId}`, payload);
    return data;
  },

  // tipo: 'carico' | 'scarico' | 'rettifica'
  movimento: async (articoloId, payload) => {
    const { data } = await apiClient.post(`/inventario/articolo/${articoloId}/movimento`, payload);
    return data;
  },

  movimenti: async (articoloId) => {
    const { data } = await apiClient.get(`/inventario/articolo/${articoloId}/movimenti`);
    return data;
  },

  archivia: async (articoloId, attivo) => {
    const { data } = await apiClient.patch(`/inventario/articolo/${articoloId}/attivo`, { attivo });
    return data;
  },

  // Cancellazione definitiva: porta via anche il registro dei movimenti.
  elimina: async (articoloId) => {
    const { data } = await apiClient.delete(`/inventario/articolo/${articoloId}`);
    return data;
  },
};
